export enum TypeChauffageEnum {
  // Commun
  CHAUDIERE_GAZ = 'CHAUDIERE_GAZ',
  POMPE_CHALEUR_ELEC = 'POMPE_CHALEUR_ELEC',
  POMPE_CHALEUR_GAZ = 'POMPE_CHALEUR_GAZ',

  // Collectif
  CHAUDIERE_FIOUL = 'CHAUDIERE_FIOUL',
  CHAUDIERE_BOIS = 'CHAUDIERE_BOIS',
  RESEAU_CHALEUR = 'RESEAU_CHALEUR',
  POMPE_CHALEUR_CHAUDIERE_GAZ = 'POMPE_CHALEUR_CHAUDIERE_GAZ',

  // Individuel
  CONVECTEURS = 'CONVECTEURS'
}
